'use strict';

function fRichtextCollapse () {
    window.addEventListener('click', function (event) {
        if (event.target.closest('.js-richtext-collapse-show')) {
            var preview = event.target.closest('.richtext__collapse').querySelector('.richtext__collapse__text-preview');
            var text = event.target.closest('.richtext__collapse').querySelector('.richtext__collapse__text');

            preview.style.display = 'none';
            text.style.display = 'block';
        }
    });
}